import * as riot from 'riot'

import {RiotPlugins, BusRiotPlugin, i18n, Url} from '@wendig/lib'

import DfkActiveFilters from '@dfk-paris/frontend/src/components/active_filters.riot'
import DfkIcon from '@dfk-paris/frontend/src/components/icon.riot'
import DfkInput from '@dfk-paris/frontend/src/components/input.riot'
import DfkPagination from '@dfk-paris/frontend/src/components/pagination.riot'
import DfkRaw from '@dfk-paris/frontend/src/components/raw.riot'

import App from './components/app.riot'
import Facet from './components/facet.riot'
import FilterLink from './components/filter_link.riot'
import FixedRelative from './components/fixed_relative.riot'
import Foldout from './components/foldout.riot'
import OrderControl from './components/order_control.riot'
import Search from './components/search.riot'
import RangeControl from './components/range_control.riot'
import Results from './components/results.riot'
import Spinner from './components/spinner.riot'
import WatchlistFilter from './components/watchlist_filter.riot'
import WatchlistToggle from './components/watchlist_toggle.riot'

import config from './lib/dotenv'

Url.setForceFragment()

i18n.locale = 'de'

i18n.fetch(`${config.STATIC_URL}/translations.json`).then(data => {
  RiotPlugins.setup(riot)
  riot.install(RiotPlugins.i18n)
  riot.install(RiotPlugins.parent)
  riot.install(RiotPlugins.setTitle)
  riot.install(BusRiotPlugin)

  riot.register('dfk-active-filters', DfkActiveFilters)
  riot.register('dfk-icon', DfkIcon)
  riot.register('dfk-input', DfkInput)
  riot.register('dfk-pagination', DfkPagination)
  riot.register('dfk-raw', DfkRaw)

  riot.register('app', App)
  riot.register('facet', Facet)
  riot.register('filter-link', FilterLink)
  riot.register('fixed-relative', FixedRelative)
  riot.register('foldout', Foldout)
  riot.register('order-control', OrderControl)
  riot.register('search', Search)
  riot.register('range-control', RangeControl)
  riot.register('results', Results)
  riot.register('spinner', Spinner)
  riot.register('watchlist-filter', WatchlistFilter)
  riot.register('watchlist-toggle', WatchlistToggle)

  riot.mount('[is]')
})
